import {
  createContext,
  Dispatch,
  ReactNode,
  useEffect,
  useReducer,
} from "react";
import firebase from "firebase/app";
import { auth } from "../firebase/config";

interface AuthStateProps {
  user: firebase.User | null;
  authIsReady: boolean;
  dispatch?: Dispatch<{
    type: string;
    payload: firebase.User | null;
  }>;
}

export const AuthContext = createContext<AuthStateProps>({
  user: null,
  authIsReady: false,
});

interface AuthContextProviderProps {
  children: ReactNode;
}

export const authReducer = (
  state: AuthStateProps,
  action: { type: string; payload: firebase.User | null },
) => {
  switch (action.type) {
    case "LOGIN":
      return { ...state, user: action.payload };
    case "LOGOUT":
      return { ...state, user: null };
    case "AUTH_IS_READY":
      return { ...state, user: action.payload, authIsReady: true };
    default:
      return state;
  }
};

export function AuthContextProvider({ children }: AuthContextProviderProps) {
  const [state, dispatch] = useReducer(authReducer, {
    user: null,
    authIsReady: false,
  });

  useEffect(() => {
    if (!state.authIsReady) {
      const unsub = auth.onAuthStateChanged((user) => {
        dispatch({ type: "AUTH_IS_READY", payload: user });
      });
      if (state.authIsReady) {
        unsub();
      }
    }
  }, [state]);

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
}
